import React from 'react';
import DatePicker from 'react-date-picker';
import moment from 'moment';
import Validator from '../../assert/Validator';


export class ControlGroup extends React.Component {
    render() {
        var hasError = this.props.errors && this.props.errors.length;
        var className = hasError ? 'form-group has-error' : 'form-group';
        return (
            <div className={className}>
                {this.props.children}
            </div>
        );
    }
}

export class ControlLabel extends React.Component {
    render() {
        var classes = "col-md-3 control-label"
        if(this.props.errors && this.props.errors.length) {
            var labelText = this.props.showErrorInLabel ? this.props.errors[0] : this.props.defaultText;
            classes += " warning"
            return (
                <label className={classes} htmlFor={this.props.name}>{labelText}</label>
            );
        }

        return (
            <label className={classes} htmlFor={this.props.name}>{this.props.defaultText}</label>
        );
    }
}

export class ControlGroupWithLabel extends React.Component {
    render() {
        return (
            <ControlGroup errors={this.props.errors}>
                <ControlLabel                    
                    errors={this.props.errors}
                    showErrorInLabel={true}
                    defaultText={this.props.defaultText} />                
                    {this.props.children}                
            </ControlGroup>
        );
    }
}

class ErrorSpan extends React.Component {
    render() {
        if(this.props.errors && this.props.errors.length) {
            return (
                <span className="help-block">{this.props.errors[0]}</span>
            );
        }
        return null;
    }
}

export class FormGroup extends React.Component {
    render() {
        return (
            <ControlGroup errors={this.props.errors}>
                <ControlLabel
                    className="col-md-3"
                    showErrorInLabel={false}
                    errors={this.props.errors}
                    defaultText={this.props.defaultText} />
                <div className="col-md-9">
                    {this.props.children}
                    <ErrorSpan {...this.props} />
                </div>
            </ControlGroup>
        );
    }
}

export class BootstrapForm extends React.Component {
    getErrors() {
        return (new Validator(this.props.inputs)).getErrors();
    }
    isValid() {
        return new Validator(this.props.inputs).passes();
    }
    render() {
        return (
            <form style={this.props.style} className={this.props.className} onSubmit={this.props.onSubmit}>
                {this.props.children}
                <input type="submit" style={{position: 'absolute', left: '-9999px' }} />
            </form>
        );
    }
    getFormData() {
        var data = {};
        if(! this.props.inputs) {
            return data;
        }

        Object.keys(this.props.inputs).forEach(inputKey => {
            data[inputKey] = this.props.inputs[inputKey].value;
        });

        return data;
    }
}

export function mergeInput(e) {
    // @todo throw exception if we don't get an event with name and value
    // undefined check
    // @todo also validate this is a React component

    console.log(this);
    var key = e.target.name;
    var value = e.target.value;
    console.log('value', value);

    var inputs = this.state.inputs;

    if(! inputs[key]) {
        // @todo throw Form Error exception
        console.warn(`key: ${key} was not found in inputs`);
    }

    inputs[key].value = value;
    this.setState({inputs});
}

export function val(key) {
    // @todo validate this is a React component
    var inputs = this.state.inputs;

    if(! inputs[key]) {
        // @todo throw Form Error exception
        console.warn(`key: ${key} was not found in inputs`);
    }

    return inputs[key].value;
}

export class DateInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datePickerVisible: false,
        };
    }
    blurDate(e){
        e.preventDefault();
        this.setState({
            datePickerVisible : false
        })
    }
    dateChange(dateString, _moment){
        this.props.onChange(dateString, _moment);
        this.setState({datePickerVisible : false});
    }
    dateClick(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            datePickerVisible : ! this.state.datePickerVisible
        });
    }
    render() {
        var formattedDate = this.props.date ? moment(this.props.date).format("YYYY-MM-DD") : null;

        return (
            <div style={this.props.style}>
                <input type="text"
                       style={{marginRight: '6px', cursor : 'pointer', textAlign: 'center'}}
                       readOnly
                       value={formattedDate}
                       onClick={this.dateClick.bind(this)} />
                {this.state.datePickerVisible &&
                    <a onClick={this.blurDate.bind(this)} href="#">Cancel</a>
                }
                {this.state.datePickerVisible &&
                    <div className="datepickerContainer">
                        <DatePicker
                            date={formattedDate}
                            onChange={this.dateChange.bind(this)}/>
                    </div>
                }
            </div>
        );
    }

}

export class DateRange extends React.Component {
    handleDateChange(field, dateVal) {
        var from = field == 'from' ? moment(dateVal).startOf('day') : this.props.from;
        var to = field == 'to' ? moment(dateVal).endOf('day') : this.props.to;
        if(to.isBefore(from)) {
            var from = moment(dateVal).startOf('day');
            var to = moment(dateVal).endOf('day');
        }

        this.props.onDateChange({from,to});
    }
    render() {
        return (
            <div>
                <strong className="pull-left" style={{marginTop : '8px', marginRight: '5px'}}>From: </strong>
                <DateInput style={{float: 'left', paddingTop: '3px'}} date={this.props.from} onChange={this.handleDateChange.bind(this, 'from')} />
                <strong className="pull-left" style={{marginTop : '8px', marginRight: '5px'}}>To: </strong>
                <DateInput style={{float: 'left', paddingTop: '3px'}} date={this.props.to} onChange={this.handleDateChange.bind(this, 'to')} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/bootstrap/Form.js